// removed by extract-text-webpack-plugin
module.exports = {"link":"guestMenu-module_link_3fMJp","item":"guestMenu-module_item_2GLPX","text":"guestMenu-module_text_2aoEX"};


//////////////////
// WEBPACK FOOTER
// ./client/components/siteHeader/header/user/guestMenu.module.css
// module id = 402
// module chunks = 1 2